import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../../../../core/auth/services/auth.service';

@Component({
  selector: 'app-auth-callback',
  standalone: true,
  templateUrl: './auth-callback.html',
  styleUrl: './auth-callback.css'
})
export class AuthCallbackComponent implements OnInit {
  private readonly msalService = inject(MsalService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  async ngOnInit(): Promise<void> {
    try {
      await this.msalService.instance.initialize();

      const result = await this.msalService.instance.handleRedirectPromise();

      if (result?.account) {
        this.msalService.instance.setActiveAccount(result.account);
      } else {
        const accounts = this.msalService.instance.getAllAccounts();

        if (accounts.length > 0) {
          this.msalService.instance.setActiveAccount(accounts[0]);
        }
      }

      this.authService.getMe().subscribe({
        next: (user) => {
          if (user?.authenticated) {
            this.authService.registrarLogAcesso().subscribe();

            // Navega para a raiz autenticada; o landingGuard decide a tela
            // inicial de acordo com as permissões do usuário (mesma lógica
            // usada em qualquer outro acesso à raiz, sem duplicar aqui).
            this.router.navigate(['/']);
            return;
          }

          this.router.navigate(['/login'], {
            queryParams: { error: 'unauthorized' }
          });
        },
        error: () => {
          this.router.navigate(['/login'], {
            queryParams: { error: 'unauthorized' }
          });
        }
      });
    } catch (error) {
      console.error('CALLBACK ERROR:', error);
      this.router.navigate(['/login'], {
        queryParams: { error: 'unauthorized' }
      });
    }
  }
}